/* eslint-disable no-const-assign */
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";

//import images
import logoSm from "../assets/images/logo-sm.png";
import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.png";

//import Components
import FullScreenDropdown from "../Components/Common/FullScreenDropdown";
import ProfileDropdown from "../Components/Common/ProfileDropdown";

import {
  changeSidebarVisibility,
} from "../slices/thunks";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

// eslint-disable-next-line react/prop-types
const Header = ({ headerClass }) => {
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);
  const observerRef = useRef(null);

  const selectDashboardData = createSelector(
    (state) => state.Layout.sidebarVisibilitytype,
    (sidebarVisibilitytype) => sidebarVisibilitytype
  );


  // Inside your component
  const sidebarVisibilitytype = useSelector(selectDashboardData);

  const [notificationDropdown, setNotificationDropdown] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const toggleNotificationDropdown = () => {
    setNotificationDropdown(!notificationDropdown);
    // Reset to page 1 when dropdown opens
    if (!notificationDropdown) {
      setCurrentPage(1);
    }
  };

  // Format time ago
  const formatTimeAgo = (timestamp) => {
    if (!timestamp) return '';

    const now = new Date();
    const notificationTime = new Date(timestamp);
    const diffInSeconds = Math.floor((now - notificationTime) / 1000);

    if (diffInSeconds < 60) return 'Just now';
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} min ago`;
    if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} hours ago`;
    return `${Math.floor(diffInSeconds / 86400)} days ago`;
  };

  // Handle notification item click - mark as read and remove highlight
  const handleNotificationItemClick = async (notification, e) => {
    e.stopPropagation();

    if (!notification || !notification._id) {
      console.error('Invalid notification object:', notification);
      return;
    }

    // Only mark as read if it's unread
    if (!notification.isRead) {
      try {
        console.log('Marking notification as read:', notification._id);
        await dispatch(markNotificationAsRead(notification._id)).unwrap();
        console.log('Successfully marked notification as read');
      } catch (error) {
        console.error('Error marking notification as read:', error);
      }
    }
  };

  // Load more notifications when scrolling to bottom
  const handleScroll = useCallback(() => {
    if (!dropdownRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = dropdownRef.current;

    // Load more when 100px from bottom
    if (scrollHeight - scrollTop - clientHeight < 100) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      dispatch(loadMoreNotifications(nextPage));
    }
  }, [currentPage, dispatch]);

  // Add scroll event listener when dropdown is open
  useEffect(() => {
    const dropdownElement = dropdownRef.current;
    if (dropdownElement && notificationDropdown) {
      dropdownElement.addEventListener('scroll', handleScroll);
      return () => dropdownElement.removeEventListener('scroll', handleScroll);
    }
  }, [notificationDropdown, handleScroll]);

  const toogleMenuBtn = () => {
    const windowSize = document.documentElement.clientWidth;
    dispatch(changeSidebarVisibility("show"));

    if (windowSize > 767)
      document.querySelector(".hamburger-icon").classList.toggle("open");

    //For collapse horizontal menu
    if (document.documentElement.getAttribute("data-layout") === "horizontal") {
      document.body.classList.contains("menu")
        ? document.body.classList.remove("menu")
        : document.body.classList.add("menu");
    }

    //For collapse vertical and semibox menu
    if (
      sidebarVisibilitytype === "show" &&
      (document.documentElement.getAttribute("data-layout") === "vertical" ||
        document.documentElement.getAttribute("data-layout") === "semibox")
    ) {
      if (windowSize < 1025 && windowSize > 767) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "sm"
          ? document.documentElement.setAttribute("data-sidebar-size", "")
          : document.documentElement.setAttribute("data-sidebar-size", "sm");
      } else if (windowSize > 1025) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "lg"
          ? document.documentElement.setAttribute("data-sidebar-size", "sm")
          : document.documentElement.setAttribute("data-sidebar-size", "lg");
      } else if (windowSize <= 767) {
        document.body.classList.add("vertical-sidebar-enable");
        document.documentElement.setAttribute("data-sidebar-size", "lg");
      }
    }

    //Two column menu
    if (document.documentElement.getAttribute("data-layout") === "twocolumn") {
      document.body.classList.contains("twocolumn-panel")
        ? document.body.classList.remove("twocolumn-panel")
        : document.body.classList.add("twocolumn-panel");
    }
  };

  return (
    <React.Fragment>
      <header id="page-topbar" className={headerClass}>
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box horizontal-logo">
                <Link to="/dashboard" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src={logoSm} alt="" height="30" />
                  </span>
                  <span className="logo-lg">
                    <img src={logoDark} alt="" height="40" />
                  </span>
                </Link>

                <Link to="/dashboard" className="logo logo-light">
                  <span className="logo-sm">
                    <img src={logoSm} alt="" height="30" />
                  </span>
                  <span className="logo-lg">
                    <img src={logoLight} alt="" height="40" />
                  </span>
                </Link>
              </div>

              <button
                onClick={toogleMenuBtn}
                type="button"
                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                id="topnav-hamburger-icon"
              >
                <span className="hamburger-icon">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>
            </div>

            <div className="d-flex align-items-center">
              <FullScreenDropdown />
              <ProfileDropdown />
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;